import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const IconContainer = styled(Link)`
  dispay: flex;
`;

export const NavIcon = styled.img`
  height: 40px;
`;